// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-action__close {
  cursor: pointer;
}

.payment-modal-content {
  width: 600px;
  background-color: white;
  padding: 40px;
  border-radius: 16px;
}

.font {
  font-family: "Noto Sans KR";
  font-style: normal;
}

.modal-header {
  font-weight: 700;
  font-size: 28px;
  color: #353d47;
}

.modal-subheader {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #566370;
}

.payment-modal-input {
  margin-top: 5px;
}
.payment-modal-input__input-box {
  margin-top: 30px;
}

.payment-modal-info {
  display: flex;
  margin-top: 30px;
}
.payment-modal-info__validity {
  width: 50%;
  padding-right: 8px;
}
.payment-modal-info__password {
  width: 50%;
}

.payment-modal-register {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/payment/payment-modal/payment-modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAGI;EACI,eAAA;AAAR;;AAIA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,2BAAA;EACA,kBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AADJ;;AAIA;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADJ;;AAIA;EACI,eAAA;AADJ;AAGI;EACI,gBAAA;AADR;;AAKA;EACI,aAAA;EACA,gBAAA;AAFJ;AAII;EACI,UAAA;EACA,kBAAA;AAFR;AAKI;EACI,UAAA;AAHR;;AAOA;EACI,gBAAA;AAJJ","sourcesContent":[".payment-modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n}\n\n.modal-action {\n    &__close {\n        cursor: pointer;\n    }\n}\n\n.payment-modal-content {\n    width: 600px;\n    background-color: white;\n    padding: 40px;\n    border-radius: 16px;\n}\n\n.font {\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n}\n\n.modal-header {\n    font-weight: 700;\n    font-size: 28px;\n    color: #353d47;\n}\n\n.modal-subheader {\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #566370;\n}\n\n.payment-modal-input {\n    margin-top: 5px;\n\n    &__input-box {\n        margin-top: 30px;\n    }\n}\n\n.payment-modal-info {\n    display: flex;\n    margin-top: 30px;\n\n    &__validity {\n        width: 50%;\n        padding-right: 8px;\n    }\n\n    &__password {\n        width: 50%;\n    }\n}\n\n.payment-modal-register {\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
